
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 10 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 .2A4.8 4.8 0 00.2 5 4.8 4.8 0 005 9.8 4.8 4.8 0 009.8 5 4.8 4.8 0 005 .2zm2.354 6.06a.232.232 0 010 .33l-.767.764a.232.232 0 01-.329 0L5 6.084l-1.26 1.27a.232.232 0 01-.33 0l-.764-.767a.232.232 0 010-.329L3.916 5l-1.27-1.26a.232.232 0 010-.329l.767-.766a.232.232 0 01.329 0L5 3.916l1.26-1.27a.232.232 0 01.329 0l.766.767a.232.232 0 010 .33L6.084 5l1.27 1.26z","fill":"#525F7F"}})])
          )
        }
      }
    